function TasksPageSubmenu({ renderItems, translate }) {
  return renderItems([
    { label: translate('list'), link: 'list' },
  ]);
}

export default TasksPageSubmenu;
